import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';

@Component({
  selector: 'app-update-shipment-details',
  templateUrl: './update-shipment-details.component.html',
  styleUrls: ['./update-shipment-details.component.scss']
})
export class UpdateShipmentDetailsComponent implements OnInit, OnChanges {

  data:any={};
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Input() InternationalShipmentsId: any;
  @Input() BookingId: any;
  @Input() ConsignmentDetailId: any;
  @Output() onDataSaved = new EventEmitter<any>();

  CargoModeId: any = {
    lable: 'Mode',
    formControlName: 'CargoModeId',
    dataField: 'CargoModeId',
    isRequired: true,
    placeholder: 'Select Mode',isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  TrackingNumber = {
    lable: 'Tracking Number',
    formControlName: 'TrackingNumber',
    dataField: 'TrackingNumber',
    // isRequired: true,
    placeholder: 'Enter Tracking Number',
  };
  
  TransportIdentifier = {
    lable: 'Transport Identifier',
    formControlName: 'TransportIdentifier',
    dataField: 'TransportIdentifier',
    // isRequired: true,
    placeholder: 'Enter Transport Identifier',
  };
  
  ContainerInfo = {
    lable: 'Container Info',
    formControlName: 'ContainerInfo',
    dataField: 'ContainerInfo',
    // isRequired: true,
    placeholder: 'Enter Container Info',
  };
  
  VoyageNo = {
    lable: 'Voyage No',
    formControlName: 'VoyageNo',
    dataField: 'VoyageNo',
    // isRequired: true,
    placeholder: 'Enter Voyage No',
  };

  userId:any;
  CargoMode:any;
  CargoModeList:any;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.GetCargoModes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['InternationalShipmentsId'] && changes['InternationalShipmentsId'].currentValue) {
      this.GetInternationalShipmentsById();
    }
  }

  getChangedValue(value, data) {
    if (value) {
      if(data.dataField === 'CargoModeId'){
        const Mode = this.CargoModeId.dropdownList.find(x => x.value === value);
        if(Mode){
            const modeName = Mode.name.toLowerCase();
            this.CargoMode = modeName;
          if(modeName === 'air'){
            this.TrackingNumber.lable='Air Waybill (AWB)';
            this.TrackingNumber.placeholder='Enter Air Waybill';
            this.TransportIdentifier.lable='Flight Number';
            this.TransportIdentifier.placeholder='Enter Flight Number';
          }else if(modeName === 'rail'|| modeName === 'train'){
            this.TrackingNumber.lable='Rail Consignment Note';
            this.TrackingNumber.placeholder='Enter Rail Consignment Note';
            this.TransportIdentifier.lable='Train Number';
            this.TransportIdentifier.placeholder='Enter Train Number';
            this.ContainerInfo.lable='Wagon number';
            this.ContainerInfo.placeholder='Enter Wagon number';
          }else if(modeName === 'sea'){
            this.TrackingNumber.lable='Bill of Lading (B/L)';
            this.TrackingNumber.placeholder='Enter Bill of Lading';
            this.TransportIdentifier.lable='Vessel Name';
            this.TransportIdentifier.placeholder='Enter Vessel Name';
            this.ContainerInfo.lable='Container number';
            this.ContainerInfo.placeholder='Enter Container number';
          }
        }
        this.data[data.dataField] = value;
      }else{
        this.data[data.dataField] = value;
      }
    }else{
      this.data[data.dataField] = null;
    }

    console.log('value:',value , 'data',this.data);
  }

  GetCargoModes() {
    this._appService.Get("OrdersByVehicle", "GetCargoModes").subscribe(
      (response) => {
        if (response) {
          response.map((x) => {
            x.name = x.Label;
            x.value = x.Id;
          });
        }
        this.CargoModeId.dropdownList = response || [];
        this.CargoModeList = response || [];
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching cargo modes data !",
          "error"
        );
      }
    );
  }

  closeModal() {
    this.onCloseBtnClick.emit();
  }

  GetInternationalShipmentsById(){
    this._appService.GetById('ShipmentModes','GetInternationalShipmentsById',this.InternationalShipmentsId).subscribe(
      (responce)=>{
        if(responce){
          this.data=responce[0];
          const modeName = this.data.CargoModeName.toLowerCase();
          this.CargoMode = modeName;
          if(modeName === 'air'){
            this.TrackingNumber.lable='Air Waybill (AWB)';
            this.TrackingNumber.placeholder='Enter Air Waybill';
            this.TransportIdentifier.lable='Flight Number';
            this.TransportIdentifier.placeholder='Enter Flight Number';
          } else if(modeName === 'rail'|| modeName === 'train'){
            this.TrackingNumber.lable='Rail Consignment Note';
            this.TrackingNumber.placeholder='Enter Rail Consignment Note';
            this.TransportIdentifier.lable='Train Number';
            this.TransportIdentifier.placeholder='Enter Train Number';
            this.ContainerInfo.lable='Wagon number';
            this.ContainerInfo.placeholder='Enter Wagon number';
          } else if(modeName === 'sea'){
            this.TrackingNumber.lable='Bill of Lading (B/L)';
            this.TrackingNumber.placeholder='Enter Bill of Lading';
            this.TransportIdentifier.lable='Vessel Name';
            this.TransportIdentifier.placeholder='Enter Vessel Name';
            this.ContainerInfo.lable='Container number';
            this.ContainerInfo.placeholder='Enter Container number';
          }
        }else{
          this.data={};
        }
      },
      (error)=>{
        this.toastr.error('Error while fetching shipment detail');
      }
    )
  }

  SaveData(){
    if(!this.data.CargoModeId){
      this.toastr.warning('Please select a Mode','Warning');
      return;
    }

    this.data.BookingId = this.BookingId;
    this.data.ConsignmentDetailId = this.ConsignmentDetailId;
    this.data.CreatedBy = this.userId;
    console.log('Savedata',this.data);
    this._appService.Post('ShipmentModes','save_InternationalShipments',this.data).subscribe(
      (response)=>{
        this.toastr.success('Added Successfully','Success');
        this.onDataSaved.emit(true);
        this.closeModal();
      },
      (error)=>{
        this.toastr.error('Error while saving data','Error');
      }
    );
  }
}
